var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tableSales"}},[_c('Datatable',{attrs:{"entity":"pos_payment","parameters":_vm.datatableParameters,"onRowClick":_vm.onRowClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }